import { RowDataTransaction } from 'ag-grid-community';

import ajax from '@/utils/ajax';

import { BillingReport, BillingReportResult, BillingReportRow } from '../types';

export interface BillingReportResultPage {
  results: BillingReportResult[];
  total_pages: number;
  page: number;
}

export const billingReportResultRepository = {
  async getBillingReport({
    host,
    billingReportId
  }: {
    host: string;
    billingReportId: string;
  }): Promise<BillingReport> {
    const response = await ajax.get({
      url: `${host}/api/billing/billing_reports/${billingReportId}/`
    });
    return response.data as BillingReport;
  },

  async listByBillingReport({
    host,
    billingReportId,
    page,
    perPage
  }: {
    host: string;
    billingReportId: string;
    page: number;
    perPage: number;
  }): Promise<BillingReportResultPage> {
    const response = await ajax.get({
      url: `${host}/api/billing/billing_report_results/?billing_report=${billingReportId}&page=${page}&page_size=${perPage}`
    });
    const data = response.data;
    return {
      results: data.results ?? data ?? [],
      total_pages: data.total_pages ?? 1,
      page: data.page ?? page
    };
  },

  async refresh({
    host,
    reportId,
    rows,
    async = false
  }: {
    host: string;
    reportId: number;
    rows: string[];
    async?: boolean;
  }): Promise<RowDataTransaction> {
    const path = `${host}/api/billing/billing_report_results/${reportId}/refresh_rows/`;
    const response = await ajax.post({ url: path, data: { billing_item_ids: rows, async } });
    return response.data as RowDataTransaction;
  },

  async submitSelectedRows({
    host,
    reportId,
    selectedRows,
    async = false
  }: {
    host: string;
    reportId: number;
    selectedRows: BillingReportRow[];
    async?: boolean;
  }): Promise<RowDataTransaction> {
    const path = `${host}/api/billing/billing_report_results/${reportId}/submit_selected_rows/`;
    const response = await ajax.post({ url: path, data: { selected_rows: selectedRows, async } });
    return response.data as RowDataTransaction;
  }
};

const BillingReportResultRepository = (
  host: string,
  reportId: number
): {
  refresh_rows: (rows: string[], async?: boolean) => Promise<RowDataTransaction>;
  submit_selected_rows: (
    selectedRows: BillingReportRow[],
    async?: boolean
  ) => Promise<RowDataTransaction>;
} => {
  return {
    async refresh_rows(rows: string[], async = false): Promise<RowDataTransaction> {
      return billingReportResultRepository.refresh({
        host,
        reportId,
        rows,
        async
      });
    },

    async submit_selected_rows(
      selectedRows: BillingReportRow[],
      async = false
    ): Promise<RowDataTransaction> {
      return billingReportResultRepository.submitSelectedRows({
        host,
        reportId,
        selectedRows,
        async
      });
    }
  };
};

export default BillingReportResultRepository;
